import { useContext, useState } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { useModal } from 'ui/components/screens/modals/useModal';
import { BuyerRequestSubsidyInfoRepository } from 'interfaceAdapter/repositories/BuyerRequestSubsidyInfo';
import { useLoading } from 'application/contexts/useLoading';

export const useSubsidyInfo = () => {
    const diContainer = useContext(diContainerContext);
    const buyerRequestSubsidyInfoRepository = diContainer.resolve(BuyerRequestSubsidyInfoRepository);
    const { setLoading } = useLoading();
    const subsidyInfoModal = useModal();
    const { openModal, createModal, closeModal } = subsidyInfoModal;
    const [showSnackbar, setShowSnackbar] = useState(false);

    const requestSubsidyInfo = async () => {
        setLoading(true);
        try {
            await buyerRequestSubsidyInfoRepository.request();
            setShowSnackbar(true);
            setTimeout(() => {
                setShowSnackbar(false);
                closeModal();
            }, 2000);
        } finally {
            setLoading(false);
        }
    };

    return {
        requestSubsidyInfo,
        openModal,
        createModal,
        showSnackbar,
        setShowSnackbar,
    };
};
